import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

const cancelSubscription =
  (makeCall: MakeCall) => (subscriptionId: number | string) =>
    makeCall('DELETE', `${APIV2_URL}/billing/subscription/${subscriptionId}`);

export default cancelSubscription;
